export const renderDataName = (type?: string, prefix?: string) => {
  if (type) {
    const tagValue = prefix ? `${prefix}--${type}` : type
    return tagValue.replace(/\s/g, '-').toLowerCase()
  }
  return ''
}
